export default function Stat_Correlation_Matrix() {
  return <div>Stat_Correlation_Matrix Component</div>;
}
